import React, { useEffect, useState, useContext /* , useMemo */ } from 'react';
import { useParams /* , useNavigate, useLocation */ } from 'react-router-dom';
import { gql, useMutation } from '@apollo/client';
import Container from 'ls-common-client/src/components/Container';
import Text from 'ls-common-client/src/components/Text';
import Anchor from 'ls-common-client/src/components/Anchor';
import Splash from 'ls-common-client/src/components/Splash';
import PropTypes from 'prop-types';
import { ExpiredInviteEnvelope, ExpiredInvitePageBackground } from '../../svgs';
import { AppContext } from '../../context';
import { auth } from '../../services';
import config from '../../config';

const { dxpUrl } = config;

const allInvitationMutations = {
  default: gql`
    mutation acceptInvitation($input: AcceptInvitationInput!) {
      acceptInvitation(input: $input) {
        success
      }
    }
  `,
  profile: gql`
    mutation acceptProfileInvitation($input: AcceptProfileInvitationInput!) {
      acceptProfileInvitation(input: $input) {
        success
      }
    }
  `,
  awsAccount: gql`
    mutation acceptAwsAccountInvitation(
      $input: AcceptAwsAccountInvitationInput!
    ) {
      acceptAwsAccountInvitation(input: $input) {
        success
      }
    }
  `,
};

const INVITATION_MUTATION_NAMES = {
  default: 'default',
  profile: 'profile',
  awsAccount: 'awsAccount',
};

const Invitations = ({ invitationMutationName }) => {
  // const { search } = useLocation();
  // const navigate = useNavigate();

  const { token } = useParams();
  const [error, setError] = useState(false);

  // const query = useMemo(() => new URLSearchParams(search), [search]);

  const {
    media: { mobile },
    user: { refetch },
  } = useContext(AppContext.Context);

  const invitationMutation =
    allInvitationMutations[invitationMutationName] ||
    allInvitationMutations.default;

  const [mutateInvitation] = useMutation(invitationMutation, {
    variables: {
      input: {
        token,
      },
    },
  });

  useEffect(() => {
    (async () => {
      try {
        await mutateInvitation();
        await refetch();
        await auth.refresh();

        window.location.href = dxpUrl || '/';
        /*
        if (query.has('redirect')) {
          window.location.href = decodeURIComponent(query.get('redirect'));
        } else {
          navigate('/');
        }
        */
      } catch (e) {
        setError(true);
      }
    })();
  }, []);

  return error ? (
    <Container
      minHeight="calc(100vh - 70px)"
      position="relative"
      display="flex"
      padding="80px 20px"
      alignItems="center"
      justifyContent="center"
    >
      <ExpiredInvitePageBackground
        style={{
          position: 'fixed',
          top: '70px',
          left: 0,
          width: '100vw',
          height: 'calc(100vh - 70px)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />
      <Container
        flexWrap="wrap-reverse"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
        gap="60px"
      >
        <Container minWidth="280px" maxWidth="430px">
          <Text
            marginBottom={mobile ? '20px' : '30px'}
            fontSize={mobile ? '31px' : '48px'}
            fontWeight="bold"
            lineHeight="1.2"
            display="block"
          >
            Invite Expired
          </Text>
          <Text
            color="text400"
            display="block"
            fontSize="18px"
            marginBottom="35px"
          >
            This invite link is no longer active. Request a new invite and
            we&apos;ll resend it right away.
          </Text>
          <Container display="flex" gap="12px" flexWrap="wrap">
            <Anchor
              display="inline-block"
              backgroundColor="primary"
              padding="12px 23px"
              borderRadius="30px"
              href="mailto:support@localsearch.com.au"
              color="white"
              fontWeight="600"
              transition="all 0.2s ease"
              _hover={{
                backgroundColor: '#1a44cc',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(40, 90, 255, 0.3)',
              }}
            >
              Request New Invite
            </Anchor>
            <Anchor
              display="inline-block"
              backgroundColor="#F8F8F8"
              padding="12px 23px"
              borderRadius="30px"
              href="tel:1300896505"
              color="#285AFF"
              fontWeight="600"
              transition="all 0.2s ease"
              _hover={{
                backgroundColor: '#EFEFEF',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
              }}
            >
              Contact Support
            </Anchor>
          </Container>
        </Container>
        <Container
          padding="0 40px"
          justifyContent="center"
          alignItems="center"
          minWidth="315px"
          maxWidth="420px"
          marginBottom="30px"
          flex="1"
          display="flex"
        >
          <Container maxWidth="420px" width="100%" position="relative">
            <ExpiredInviteEnvelope width="100%" />
          </Container>
        </Container>
      </Container>
    </Container>
  ) : (
    <Container
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Splash />
    </Container>
  );
};

Invitations.propTypes = {
  invitationMutationName: PropTypes.string.isRequired,
};

export default Invitations;

export { INVITATION_MUTATION_NAMES };
